import React from 'react'
import cx from 'classnames'
import Image from '/js/views/shared/components/contentParticles/image'
import Video from '/js/views/shared/components/contentParticles/video'
import DataTable from '/js/views/shared/components/contentParticles/dataTable'
import { Citations } from '../citations'

class StoryOverlaySectionItem extends React.Component {
  renderImage(image, index) {
    return (
      <div
        className={cx('mb-20', {
          'max-w-256': image.inline,
        })}
        key={`image-${index}`}
      >
        <Image images={image} />
      </div>
    )
  }

  renderVideo(video, index) {
    const { theme } = this.props

    return (
      <div className="mb-32" key={`video-${index}`}>
        <Video content={video} theme={theme} inline={true} />
      </div>
    )
  }

  renderListItems(list) {
    return list.map((item, index) => (
      <li
        className="mb-15"
        key={`list-item-${index}`}
        dangerouslySetInnerHTML={{ __html: item }}
      />
    ))
  }

  renderOrderedList(list, index) {
    const { theme } = this.props
    const customColor =
      theme.textColor === '' ? theme.textColor : ''

    return (
      <ol className={`list-decimal ml-15 ${customColor}`} key={`ol-${index}`}>
        {this.renderListItems(list)}
      </ol>
    )
  }

  renderUnorderedList(list, index) {
    const { theme } = this.props
    const customColor =
      theme.textColor === '' ? theme.textColor : ''

    return (
      <ul className={`list-disc ml-15 ${customColor}`} key={`ul-${index}`}>
        {this.renderListItems(list)}
      </ul>
    )
  }

  renderCaption(caption, index) {
    return (
      <p
        key={`caption-${index}`}
        className="text-granite-gray mb-32"
        dangerouslySetInnerHTML={{ __html: caption }}
      />
    )
  }

  renderQuote(quote, isDarkMode, index) {
    const { theme } = this.props
    const colorClass = isDarkMode ? 'text-white' : 'text-granite-gray'

    return (
      <blockquote
        key={`quote-${index}`}
        className={`mb-15 border-l-6 pl-25 ${theme.borderColor}`}
      >
        <p
          className={`md:text-24 mb-10 ${theme.textColor}`}
          dangerouslySetInnerHTML={{ __html: quote.content }}
        />
        <footer
          className={`text-14 text-right ${colorClass}`}
          dangerouslySetInnerHTML={{ __html: quote.citation }}
        />
      </blockquote>
    )
  }

  renderParagraph(text, index) {
    return (
      <p
        className="mb-15"
        key={`paragraph-${index}`}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    )
  }

  renderInlineTitle(title, isDarkMode, index) {
    const { theme } = this.props
    const colorClass =
      theme.textColor === 'text-danaher-blue' && isDarkMode
        ? 'text-white'
        : theme.textColor
    return (
      <h5
        className={`uppercase font-condensed text-18 xl:text-24 mb-10 ${colorClass}`}
        key={`title-${index}`}
        dangerouslySetInnerHTML={{ __html: title }}
      />
    )
  }

  renderHighlightedContent(highlightedContent, index) {
    return (
      <div
        className="bg-jet-black text-white rounded-tr rounded-bl px-32 py-25 mb-32"
        key={`highlighted-content-${index}`}
      >
        {this.renderContent(highlightedContent, true)}
      </div>
    )
  }

  renderContent(content, isDarkMode = false) {
    const { theme } = this.props

    return content.map((contentItem, index) => {
      switch (Object.keys(contentItem)[0]) {
        case 'highlightedContent':
          return this.renderHighlightedContent(
            Object.values(contentItem)[0],
            index
          )
        case 'inlineTitle':
          return this.renderInlineTitle(
            Object.values(contentItem)[0],
            isDarkMode,
            index
          )
        case 'text':
          return this.renderParagraph(Object.values(contentItem)[0], index)
        case 'quote':
          return this.renderQuote(
            Object.values(contentItem)[0],
            isDarkMode,
            index
          )
        case 'citations':
          return <Citations className="mb-10" key={`citations-${index}`} citations={Object.values(contentItem)[0]} />
        case 'caption':
          return this.renderCaption(Object.values(contentItem)[0], index)
        case 'unorderedList':
          return this.renderUnorderedList(Object.values(contentItem)[0], index)
        case 'orderedList':
          return this.renderOrderedList(Object.values(contentItem)[0], index)
        case 'video':
          return this.renderVideo(Object.values(contentItem)[0], index)
        case 'images':
          return this.renderImage(Object.values(contentItem)[0], index)
        case 'dataTable':
          return (
            <DataTable
              content={Object.values(contentItem)[0]}
              theme={theme}
              key={`data-table-${index}`}
            />
          )
        default:
          return null
      }
    })
  }
  4
  render() {
    const { content, theme, style } = this.props

    if (content.expandableContent.length <= 0) {
      return null
    }

    return (
      <div
        style={style}
        className="border-b-4 border-smoke-white mb-32 pb-25 pt-30"
      >
        {!content.hideTitle && (
          <div
            className={cx('mb-10', {
              'flex flex-wrap': content.sdg,
            })}
          >
            <h4
              className={cx(
                `uppercase font-condensed text-18 xl:text-24 ${theme.textColor}`,
                {
                  ' md:mr-auto md:self-end': content.sdg,
                }
              )}
              dangerouslySetInnerHTML={{ __html: content.title }}
            />
            {content.sdg &&
              content.sdg.map((icon, index) => {
                return (
                  <div
                    key={index}
                    className={cx({
                      'ml-10': index === 0 && content.sdg.length === 1,
                      'mr-10': index === 0 && content.sdg.length > 1,
                    })}
                  >
                    <a className="block" href="/appendix#un">
                      <Image key={index} images={icon} sdg />
                    </a>
                  </div>
                )
              })}
          </div>
        )}
        {this.renderContent(content.expandableContent)}
      </div>
    )
  }
}

export default StoryOverlaySectionItem
